<template>
	<main class="vx-row">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2">
			<h3 class="mb-6"><strong>Tambah Rekening Bank</strong></h3>
			<form>
				<div class="mb-4">
					<strong class="block mb-3">
						Nama
					</strong>
					<vs-input
					    class="w-full rounded-lg"
					/>
				</div>
				<div class="mb-4">
					<strong class="block mb-3">
						No. Rekening
					</strong>
					<vs-input
					    class="w-full rounded-lg"
					/>
				</div>
				<div class="mb-8">
					<strong class="block mb-3">
						Nama Bank
					</strong>
					<vs-input
					    class="w-full rounded-lg"
					/>
				</div>
				<div class="mb-4 flex w-full">
					<vs-button 
						color="#bbb" 
						class="w-full mx-2"
						@click.prevent="backProfilePayment"
					>
						<strong class="text-white">Kembali</strong>
					</vs-button>
					<vs-button color="primary" class="w-full mx-2">
						<strong class="text-warning">Tambah</strong>
					</vs-button>
				</div>
			</form>
		</div>
	</main>
</template>
<script>
	export default {
		methods: {
			backProfilePayment() {
				this.$emit('backProfilePayment')
			}
		}
	}
</script>